



























































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { ReleaseNotes } from "@/models/releaseNotes";
import VaCard from "../molecules/VaCard.vue";
import SoftwareVersionRow from "../organisms/SoftwareVersionRow.vue";
import SoftwareMagoDisplay from "./SoftwareMagoDisplay.vue";

export default Vue.extend({
  name: "SoftwareMago",
  components: { VaCard, SoftwareVersionRow, SoftwareMagoDisplay },

  data() {
    return {
      selectedSlot: "pro",
    };
  },
  methods: {},
  computed: {
    room() {
      const notes = this.$store.getters["cms/releaseNotes"];
      return notes.filter(
        (note: ReleaseNotes) => !note.fastChannel && note.product == "room"
      )[0];
    },
    roomFastchannel() {
      const notes = this.$store.getters["cms/releaseNotes"];
      return notes.filter(
        (note: ReleaseNotes) => note.fastChannel && note.product == "room"
      )[0];
    },
    controllerAndroid() {
      const notes = this.$store.getters["cms/releaseNotes"];
      return notes.filter(
        (note: ReleaseNotes) =>
          note.os == "android" && note.product == "controller"
      )[0];
    },
    controllerIos() {
      const notes = this.$store.getters["cms/releaseNotes"];
      return notes.filter(
        (note: ReleaseNotes) => note.os == "ios" && note.product == "controller"
      )[0];
    },
    appAndroid() {
      const notes = this.$store.getters["cms/releaseNotes"];
      return notes.filter(
        (note: ReleaseNotes) => note.os == "android" && note.product == "app"
      )[0];
    },
    appIos() {
      const notes = this.$store.getters["cms/releaseNotes"];
      return notes.filter(
        (note: ReleaseNotes) => note.os == "ios" && note.product == "app"
      )[0];
    },
  },
});
